import InboxPage from '../InboxPage';
export default function AgentInboxPage() { return <InboxPage role="agent" />; }
